!function() {
  "use strict";
  if (!customElements.get("slideshow-component")) {
    customElements.define("slideshow-component", class extends HTMLElement {
      constructor() {
        super();
        this.flkty = null;
        this.flktyResizeEvent = () => { if (this.flkty) this.flkty.resize(); };
        this.getTallestSlideItemEvent = () => this.getTallestSlideItem();
      }

      connectedCallback() {
        if ('IntersectionObserver' in window && !this.classList.contains('slider--first')) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.init();
                observer.unobserve(this);
              }
            });
          }, { rootMargin: '600px' });
          observer.observe(this);
        } else {
          this.init();
        }
      }

      init() {
        this.items = this.querySelectorAll("[data-slide]");
        this.getTallestSlideItem();
        this.initSlider();
        this.bindScrollButton();
        document.addEventListener("theme:resize:width", this.getTallestSlideItemEvent);
      }

      initSlider() {
        const itemCount = this.items.length;
        const duration = parseInt(this.dataset.duration);
        const pageDots = this.dataset.pageDots === "true" && itemCount > 1;
        const navArrows = this.dataset.navArrows === "true" && itemCount > 1;
        let autoplay = this.dataset.autoplay === "true";
        if (autoplay) autoplay = duration;

        if (itemCount > 1) {
          this.flkty = new window.theme.Flickity(this, {
            fade: true,
            cellSelector: "[data-slide]",
            autoPlay: autoplay,
            wrapAround: true,
            adaptiveHeight: true,
            setGallerySize: true,
            imagesLoaded: true,
            pageDots: pageDots,
            prevNextButtons: navArrows,
            dragThreshold: 25,
            on: {
              ready: () => {
                requestAnimationFrame(this.flktyResizeEvent);
                document.addEventListener("theme:vars", this.flktyResizeEvent);
                this.handleFirstSlideAnimation(true);
              },
              change: (index) => {
                this.handleFirstSlideAnimation(false);
                this.flkty.cells.forEach((cell, i) => {
                  cell.element.querySelectorAll("a, button").forEach(btn => {
                    btn.setAttribute("tabindex", i === index ? "0" : "-1");
                  });
                  cell.element.querySelectorAll("text-highlight").forEach(th => {
                    th.setTriggerAttribute(Boolean(i === index));
                  });
                });
              }
            }
          });
          if (window.theme.flickitySmoothScrolling) {
            window.theme.flickitySmoothScrolling(this);
          }
        }
      }

      getTallestSlideItem() {
        if (this.items.length <= 1) return;
        this.style.removeProperty("--item-min-h");
        const heights = [...this.items].map(item => Math.floor(item.offsetHeight));
        const maxHeight = Math.max(...heights);
        const isOriginalHeight = [...this.items].some(item => item.classList.contains("original-height"));
        const isOriginalHeightMobile = [...this.items].some(item => item.classList.contains("original-height-mobile"));
        const isMobileHeight = this.classList.contains("has-mobile-height");

        const shouldSetHeight = (window.theme.isDesktop() && !isOriginalHeight) ||
                                (window.theme.isMobile() && !isOriginalHeightMobile && isMobileHeight) ||
                                (window.theme.isMobile() && !isOriginalHeight && !isMobileHeight);

        if (shouldSetHeight) {
          const hasVaryingHeights = [...this.items].some(item => Math.floor(item.offsetHeight) !== maxHeight);
          if (hasVaryingHeights) {
            this.style.setProperty("--item-min-h", `${maxHeight}px`);
          }
        }
      }

      handleFirstSlideAnimation(isFirst = false) {
        if (!isFirst) {
          this.classList.remove("slider--no-cached-images");
          this.classList.remove("slider--img-loaded");
          return;
        }
        const lazyImages = this.items[0].querySelectorAll(".lazy-image");
        const isImgIn = this.classList.contains("img-in");
        if (lazyImages.length && !isImgIn) {
          this.classList.add("slider--no-cached-images");
          const onTransitionEnd = () => {
            requestAnimationFrame(() => this.classList.add("slider--img-loaded"));
            lazyImages[0].removeEventListener("transitionend", onTransitionEnd);
          };
          lazyImages[0].addEventListener("transitionend", onTransitionEnd);
        }
      }

      bindScrollButton() {
        const scrollBtn = this.querySelector("[data-scroll-down]");
        if (scrollBtn) {
          scrollBtn.addEventListener("click", (e) => {
            e.preventDefault();
            const header = document.querySelector("[data-site-header]");
            const headerHeight = (header && header.classList.contains("site-header--fixed")) ? 60 : 0;
            const top = parseInt(Math.ceil(this.offsetTop + this.offsetHeight - headerHeight));
            window.scrollTo({ top, left: 0, behavior: "smooth" });
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener("theme:resize:width", this.getTallestSlideItemEvent);
        document.removeEventListener("theme:vars", this.flktyResizeEvent);
      }
    });
  }
}();
